import {
  Container,
  NavigationHeaderContainer,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateTree/shared';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

const TreeNavigationNullState = () => (
  <Container aria-label='Inquiry template steps'>
    <NavigationHeaderContainer>
      Steps
      <Spacer height={1.5} />
      <Paragraph size='sm'>Loading nav items...</Paragraph>
    </NavigationHeaderContainer>
  </Container>
);

export default TreeNavigationNullState;
